import { createOperation } from "../operations";

export const addVenueCauseOperation = createOperation<void>("PAYMENT/ADD_VENUE_CAUSE", { showSpinner: true });
export const removeVenueCauseOperation = createOperation<void>("PAYMENT/REMOVE_VENUE_CAUSE", {
    tracked: true,
    showSpinner: true,
});
